module.exports = __webpack_public_path__ + "img/button_join.8b4cf5f7.svg";